export default __webpack_public_path__ + "static/media/close-filters.d063c1e3.svg";